import Notice from "./notice";
import { ReDealModal } from "./reDealModal";

export default class ModalsManager {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;

    this.notice = new Notice(this.scene, this.table);
    this.reDealModal = new ReDealModal(this.scene, this.table);
  }
  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    this.notice.positionControls(width, height, initX, initY);
    // this.reDealModal.positionControls(width, height, initX, initY);
  }
  reposition(width, height, initX, initY) {
    this.notice.reposition(width, height, initX, initY);
  }
  remove() {
    this.notice.remove();
  }
}
